import { render } from "./Main.vue?vue&type=template&id=6e561cbc&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=6e561cbc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6e561cbc"

export default script